import {
  defineComponent, ref, watch, computed, cloneVNode, PropType, VNode, render,
} from 'vue'
import { Icon } from '../Icon'
import { Text } from '../Text'
import { Spin } from './assets'
import { getRealDomTarget } from './utils'

import { Position, SpinnerSize, SpinnerTheme } from '../../enums'

export default defineComponent({
  inheritAttrs: false,
  props: {
    size: {
      type: String as PropType<SpinnerSize>,
      default: 'default',
    },
    theme: {
      type: String as PropType<SpinnerTheme>,
      default: 'default',
    },
    tip: {
      type: String,
      default: undefined,
    },
    spinning: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { slots, attrs }) {
    const spinnerTarget = ref<VNode>()

    const spinner = computed(
      () => (
        props.spinning
          ? <span
            class={'d-spinner'}
          >
            <span class={'d-spinner-indicator'}>
              {
                slots.indicator?.() || <Icon
                  size={props.size}
                  class={
                    [
                      props.theme === 'reverse'
                        ? '--color-white'
                        : '--color-primary',
                    ]
                  }
                  spin
                >
                  <Spin/>
                </Icon>
              }
            </span>
            {
              slots.tip?.() || (
                props.tip && <Text
                  class={
                    [
                      props.theme === 'reverse'
                        ? '--color-white'
                        : '--color-text-title',
                    ]
                  }
                  type={
                    props.size === 'large'
                      ? 'h6'
                      : 'paragraph'
                  }
                  color={'current'}
                  bold
                  ellipsis
                >
                  {props.tip}
                </Text>
              )
            }
          </span>
          : null
      ),
    )

    watch(
      [
        spinnerTarget,
        spinner,
      ],
      ([target, s]) => {
        if (target) {
          const el = getRealDomTarget(target)

          if (el) {
            const position = getComputedStyle(el).position as Position

            if (position === 'static') {
              el.style.position = 'relative'
            }

            render(
              s && <span
                class={'d-spinner-mask'}
                {...attrs}
              >
                {s}
              </span>,
              el,
            )
          }
        }
      },
    )

    return () => (
      slots.default
        ? slots.default()
          .map(
            (slot, i) => {
              if (i === 0) {
                return cloneVNode(
                  slot,
                  {
                    onVnodeMounted(node) {
                      spinnerTarget.value = node
                    },
                  },
                )
              }

              return slot
            },
          )
        : spinner.value
    )
  },
})
